import { useEffect } from "react";
import Commodity from '../table/Tabledispatch';
import Modal from "../modal/Modaldispatch"



const Dashboard = () => {
  useEffect(() => {
    // getPromise(["sales", "purchases"]);
  }, []);


  return (
    <>
    {/* <Modal/> */}
    <Commodity/>
    
     
     </>
  );
};

export default Dashboard;
